tinymce.addI18n("id", {
    "#": "#",
    "Accessibility": "Aksesibilitas",
    "Accordion": "Accordion",
    "Accordion body...": "Badan accordion...",
    "Accordion summary...": "Ringkasan accordion...",
    "Action": "Tindakan",
    "Activity": "Aktivitas",
    "Address": "Alamat",
    "Advanced": "Lanjutan",
    "Align": "Sejajarkan",
    "Align center": "Rata tengah",
    "Align left": "Rata kiri",
    "Align right": "Rata kanan",
    "Alignment": "Penyejajaran",
    "Alignment {0}": "Perataan {0}",
    "All": "Semua",
    "Alternative description": "Deskripsi alternatif",
    "Alternative source": "Sumber alternatif",
    "Alternative source URL": "URL Sumber alternatif",
    "Anchor": "Jangkar",
    "Anchor...": "Jangkar..",
    "Anchors": "Jangkar",
    "Animals and Nature": "Hewan dan Alam",
    "Arrows": "Panah",
    "B": "B",
    "Background color": "Warna latar belakang",
    "Background color {0}": "Warna latar belakang {0}",
    "Black": "Hitam",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Kutipan",
    "Blocks": "Blok",
    "Blue": "Biru",
    "Blue component": "Komponen biru",
    "Body": "Badan",
    "Bold": "Tebal",
    "Border": "Batas",
    "Border color": "Warna pinggiran",
    "Border style": "Gaya pinggiran",
    "Border width": "Lebar pinggiran",
    "Bottom": "Bawah",
    "Browse files": "Jelajahi file",
    "Browse for an image": "Jelajahi gambar",
    "Browse links": "Jelajahi tautan",
    "Bullet list": "Daftar bersimbol",
    "Cancel": "Batal",
    "Caption": "Judul",
    "Cell": "Sel",
    "Cell padding": "Lapisan sel",
    "Cell properties": "Properti sel",
    "Cell spacing": "Jarak sel",
    "Cell styles": "Corak sel",
    "Cell type": "Tipe sel",
    "Center": "Tengah",
    "Characters": "Karakter",
    "Characters (no spaces)": "Karakter (tanpa spasi)",
    "Circle": "Lingkaran",
    "Class": "Kelas",
    "Clear formatting": "Kosongkan format",
    "Close": "Tutup",
    "Code": "Kode",
    "Code sample...": "Sampel kode...",
    "Code view": "Tampilan Kode",
    "Color Picker": "Pemilih warna",
    "Color swatch": "Contoh warna",
    "Cols": "Kolom",
    "Column": "Kolom",
    "Column clipboard actions": "Aksi kolom clipboard",
    "Column group": "Grup kolom",
    "Column header": "Kepala kolom",
    "Constrain proportions": "Pertahankan proporsi",
    "Copy": "Salin",
    "Copy column": "Salin kolom",
    "Copy row": "Salin baris",
    "Could not find the specified string.": "Tidak dapat menemukan string yang dimaksud.",
    "Could not load emojis": "Tidak dapat memuat emoji",
    "Count": "Hitungan",
    "Currency": "Mata Uang",
    "Current window": "Jendela saat ini",
    "Custom color": "Warna khusus",
    "Custom...": "Khusus...",
    "Cut": "Potong",
    "Cut column": "Potong kolom",
    "Cut row": "Potong baris",
    "Dark Blue": "Biru Gelap",
    "Dark Gray": "Abu Gelap",
    "Dark Green": "Hijau Gelap",
    "Dark Orange": "Jingga Gelap",
    "Dark Purple": "Ungu Gelap",
    "Dark Red": "Merah Gelap",
    "Dark Turquoise": "Turquoise Gelap",
    "Dark Yellow": "Kuning Gelap",
    "Dashed": "Garis-garis",
    "Date/time": "Tanggal/waktu",
    "Decrease indent": "Kurangi inden",
    "Default": "Bawaan",
    "Delete accordion": "Hapus accordion",
    "Delete column": "Hapus kolom",
    "Delete row": "Hapus baris",
    "Delete table": "Hapus tabel",
    "Dimensions": "Dimensi",
    "Disc": "Cakram",
    "Div": "Div",
    "Document": "Dokumen",
    "Dotted": "Titik-titik",
    "Double": "Ganda",
    "Drop an image here": "Letakkan gambar di sini",
    "Dropped file type is not supported": "Jenis file yang dijatuhkan tidak didukung",
    "Edit": "Edit",
    "Embed": "Semat",
    "Emojis": "Emoji",
    "Emojis...": "Emoji...",
    "Error": "Kesalahan",
    "Error: Form submit field collision.": "Kesalahan: Benturan bidang pengiriman bentuk.",
    "Error: No form element found.": "Kesalahan: tidak ditemukan elemen bentuk.",
    "Extended Latin": "Latin Diperluas",
    "Failed to initialize plugin: {0}": "Gagal memulai plugin: {0}",
    "Failed to load plugin url: {0}": "Gagal memuat url plugin: {0}",
    "Failed to load plugin: {0} from url {1}": "Gagal memuat plugin: {0} dari url {1}",
    "Failed to upload image: {0}": "Gagal mengunggah gambar: {0}",
    "File": "Berkas",
    "Find": "Cari",
    "Find (if searchreplace plugin activated)": "Cari (jika plugin cari ganti diaktifkan)",
    "Find and Replace": "Temukan dan Ganti",
    "Find and replace...": "Cari dan ganti...",
    "Find in selection": "Cari dari yang dipilih",
    "Find whole words only": "Cari hanya kata utuh",
    "Flags": "Bendera",
    "Focus to contextual toolbar": "Fokus ke bilah alat kontekstual",
    "Focus to element path": "Fokus ke alur elemen",
    "Focus to menubar": "Fokus ke bilah menu",
    "Focus to toolbar": "Fokus ke bilah alat",
    "Font": "Huruf",
    "Font size {0}": "Ukuran font {0}",
    "Font sizes": "Ukuran huruf",
    "Font {0}": "Font {0}",
    "Fonts": "Huruf",
    "Food and Drink": "Makanan dan Minuman",
    "Footer": "Catatan kaki",
    "Format": "Format",
    "Format {0}": "Format {0}",
    "Formats": "Format",
    "Fullscreen": "Layar penuh",
    "G": "G",
    "General": "Umum",
    "Gray": "Abu-abu",
    "Green": "Hijau",
    "Green component": "Komponen hijau",
    "Groove": "Tumbuh",
    "Handy Shortcuts": "Pintasan Bermanfaat",
    "Header": "Judul",
    "Header cell": "Sel judul",
    "Heading 1": "Kepala 1",
    "Heading 2": "Kepala 2",
    "Heading 3": "Kepala 3",
    "Heading 4": "Kepala 4",
    "Heading 5": "Kepala 5",
    "Heading 6": "Kepala 6",
    "Headings": "Kepala",
    "Height": "Tinggi",
    "Help": "Bantuan",
    "Hex color code": "Kode warna hex",
    "Hidden": "Sembunyi",
    "Horizontal align": "Sejajar horisontal",
    "Horizontal line": "Garis horizontal",
    "Horizontal space": "Ruang horizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID harus dimulai dengan huruf, lalu diikuti hanya oleh huruf, angka, garis pisah, titik, titik dua, atau garis bawah.",
    "Image is decorative": "Gambar Hiasan",
    "Image list": "Daftar gambar",
    "Image title": "Judul gambar",
    "Image...": "Gambar...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Kesalahan HTTP ImageProxy: Tidak dapat menemukan Proxy Gambar",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Kesalahan HTTP ImageProxy: URL Proxy Gambar Salah",
    "ImageProxy HTTP error: Rejected request": "Kesalahan HTTP ImageProxy: Permintaan ditolak",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Kesalahan HTTP ImageProxy: Kesalahan Proxy Gambar tidak diketahui",
    "Increase indent": "Tambah inden",
    "Inline": "Baris",
    "Insert": "Masukkan",
    "Insert Template": "Masukkan Template",
    "Insert accordion": "Masukkan accordion",
    "Insert column after": "Masukkan kolom setelah",
    "Insert column before": "Masukkan kolom sebelum",
    "Insert date/time": "Masukkan tanggal/waktu",
    "Insert image": "Masukkan gambar",
    "Insert link (if link plugin activated)": "Masukan tautan (jika plugin tautan diaktifkan)",
    "Insert row after": "Sisipkan baris setelah",
    "Insert row before": "Sisipkan baris sebelum",
    "Insert table": "Masukkan tabel",
    "Insert template...": "Masukkan template...",
    "Insert video": "Masukkan video",
    "Insert/Edit code sample": "Tambah/Edit sampel kode",
    "Insert/edit image": "Masukkan/edit gambar",
    "Insert/edit link": "Masukkan/edit tautan",
    "Insert/edit media": "Masukkan/edit media",
    "Insert/edit video": "Masukkan/edit video",
    "Inset": "Inset",
    "Invalid hex color code: {0}": "Kode warna hex tidak valid: {0}",
    "Invalid input": "Masukan tidak valid",
    "Italic": "Miring",
    "Justify": "Rata penuh",
    "Keyboard Navigation": "Navigasi Keyboard",
    "Language": "Bahasa",
    "Learn more...": "Ketahui selengkapnya...",
    "Left": "Kiri",
    "Left to right": "Kiri ke kanan",
    "Light Blue": "Biru Muda",
    "Light Gray": "Abu Muda",
    "Light Green": "Hijau Muda",
    "Light Purple": "Ungu Muda",
    "Light Red": "Merah Muda",
    "Light Yellow": "Kuning Muda",
    "Line height": "Tinggi baris",
    "Link list": "Daftar tautan",
    "Link...": "Tautan...",
    "List Properties": "Daftar properti",
    "List properties...": "Daftar properti...",
    "Loading emojis...": "Memuat emoji...",
    "Loading...": "Memuat...",
    "Lower Alpha": "Huruf Kecil",
    "Lower Greek": "Huruf Kecil Yunani",
    "Lower Roman": "Huruf Kecil Romawi",
    "Match case": "Samakan besar kecil huruf",
    "Mathematical": "Matematis",
    "Media poster (Image URL)": "Poster media (URL gambar)",
    "Media...": "Media...",
    "Medium Blue": "Biru Medium",
    "Medium Gray": "Abu Medium",
    "Medium Purple": "Ungu Medium",
    "Merge cells": "Gabung sel",
    "Middle": "Tengah",
    "Midnight Blue": "Biru Midnight",
    "More...": "Lainnya...",
    "Name": "Nama",
    "Navy Blue": "Biru Navy",
    "New document": "Dokumen baru",
    "New window": "Jendela baru",
    "Next": "Berikutnya",
    "No": "Tidak",
    "No alignment": "Tanpa pejajaran",
    "No color": "Tanpa berwarna",
    "Nonbreaking space": "Spasi",
    "None": "Tidak ada",
    "Numbered list": "Daftar bernomor",
    "OR": "ATAU",
    "Objects": "Objek",
    "Ok": "Ok",
    "Open help dialog": "Buka dialog bantuan",
    "Open link": "Buka tautan",
    "Open link in...": "Buka tautan dalam...",
    "Open popup menu for split buttons": "Buka menu popup untuk tombol terpisah",
    "Orange": "Jingga",
    "Outset": "Outset",
    "Page break": "Halaman baru",
    "Paragraph": "Paragraf",
    "Paste": "Rekat",
    "Paste as text": "Rekatkan sebagai teks",
    "Paste column after": "Tempel kolom ke setelah",
    "Paste column before": "Tempel kolom ke sebelum",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Tempel sekarang dalam mode teks biasa. Konten sekarang akan ditempelkan sebagai teks biasa hingga Anda mematikan pilihan ini.",
    "Paste or type a link": "Rekat atau ketik tautan",
    "Paste row after": "Rekat baris setelah",
    "Paste row before": "Rekat baris sebelum",
    "Paste your embed code below:": "Rekatkan kode sematan di bawah:",
    "People": "Orang",
    "Plugins": "Plugin",
    "Plugins installed ({0}):": "Plugin terpasang ({0}):",
    "Powered by {0}": "Didayai oleh {0}",
    "Pre": "Pre",
    "Preferences": "Preferensi",
    "Preformatted": "Praformat",
    "Premium plugins:": "Plugin premium:",
    "Press the Up and Down arrow keys to resize the editor.": "Tekan tombol panah Atas dan Bawah untuk mengubah ukuran editor.",
    "Press the arrow keys to resize the editor.": "Tekan tombol panah untuk mengubah ukuran editor.",
    "Press {0} for help": "Tekan {0} untuk bantuan",
    "Preview": "Pratinjau",
    "Previous": "Sebelumnya",
    "Print": "Cetak",
    "Print...": "Cetak...",
    "Purple": "Ungu",
    "Quotations": "Kutipan",
    "R": "R",
    "Range 0 to 255": "Rentang 0 hingga 255",
    "Red": "Merah",
    "Red component": "Komponen merah",
    "Redo": "Ulang",
    "Remove": "Hapus",
    "Remove color": "Hapus warna",
    "Remove link": "Hapus tautan",
    "Replace": "Ganti",
    "Replace all": "Ganti semua",
    "Replace with": "Ganti dengan",
    "Resize": "Ubah ukuran",
    "Restore last draft": "Pulihkan draf sebelumnya",
    "Reveal or hide additional toolbar items": "Tampilkan atau sembunyikan item bilah alat tambahan",
    "Rich Text Area": "Area Rich Text",
    "Rich Text Area. Press ALT-0 for help.": "Area Teks Kaya. Tekan ALT-0 untuk bantuan.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Area Teks Kaya. Tekan ALT-F9 untuk menu. Tekan ALT-F10 untuk bilah alat. Tekan ALT-0 untuk bantuan",
    "Ridge": "Kerut",
    "Right": "Kanan",
    "Right to left": "Kanan ke kiri",
    "Row": "Baris",
    "Row clipboard actions": "Aksi baris clipboard",
    "Row group": "Grup baris",
    "Row header": "Baris kolom",
    "Row properties": "Properti baris",
    "Row type": "Tipe baris",
    "Rows": "Baris",
    "Save": "Simpan",
    "Save (if save plugin activated)": "Simpan (jika plugin simpan diaktifkan)",
    "Scope": "Cakupan",
    "Search": "Cari",
    "Select all": "Pilih semua",
    "Select...": "Pilih...",
    "Selection": "Pemilihan",
    "Shortcut": "Pintasan",
    "Show blocks": "Tampilkan blok",
    "Show caption": "Perlihatkan keterangan",
    "Show invisible characters": "Tampilkan karakter tak tampak",
    "Size": "Ukuran",
    "Solid": "Padat",
    "Source": "Sumber",
    "Source code": "Kode sumber",
    "Special Character": "Karakter Khusus",
    "Special character...": "Karakter khusus...",
    "Split cell": "Bagi sel",
    "Square": "Kotak",
    "Start list at number": "Mulai daftar dari nomor",
    "Strikethrough": "Coret",
    "Style": "Gaya",
    "Subscript": "Subskrip",
    "Superscript": "Superskrip",
    "Switch to or from fullscreen mode": "Alihkan ke atau dari mode layar penuh",
    "Symbols": "Simbol",
    "System Font": "Huruf Sistem",
    "Table": "Tabel",
    "Table caption": "Judul tabel",
    "Table properties": "Properti tabel",
    "Table styles": "Corak tabel",
    "Template": "Template",
    "Templates": "Template",
    "Text": "Teks",
    "Text color": "Warna teks",
    "Text color {0}": "Warna teks {0}",
    "Text to display": "Teks yang akan ditampilkan",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL yang dimasukkan sepertinya adalah alamat email. Apakah Anda ingin menambahkan prefiks mailto: yang dibutuhkan?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Tautan yang dimasukkan sepertinya adalah tautan eksternal. Apakah Anda ingin menambahkan prefiks http:// yang dibutuhkan?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "URL yang Anda masukkan tampaknya merupakan tautan eksternal. Apakah Anda ingin menambahkan awalan https:// yang diperlukan?",
    "Title": "Judul",
    "To open the popup, press Shift+Enter": "Untuk membuka popup, tekan Shift+Enter",
    "Toggle accordion": "Alih accordion",
    "Tools": "Alat",
    "Top": "Atas",
    "Travel and Places": "Perjalanan dan Lokasi",
    "Turquoise": "Toska",
    "Underline": "Garis bawah",
    "Undo": "Batalkan",
    "Upload": "Unggah",
    "Uploading image": "Unggah gambar",
    "Upper Alpha": "Huruf Besar",
    "Upper Roman": "Huruf Besar Romawi",
    "Url": "Url",
    "User Defined": "Ditentukan Pengguna",
    "Valid": "Valid",
    "Version": "Versi",
    "Vertical align": "Sejajar vertikal",
    "Vertical space": "Ruang vertikal",
    "View": "Tampilkan",
    "Visual aids": "Alat bantu visual",
    "Warn": "Peringatkan",
    "White": "Putih",
    "Width": "Lebar",
    "Word count": "Hitungan kata",
    "Words": "Kata",
    "Words: {0}": "Kata: {0}",
    "Yellow": "Kuning",
    "Yes": "Ya",
    "You are using {0}": "Anda menggunakan {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Anda memiliki perubahan yang belum disimpan, yakin ingin beralih ?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Browser anda tidak mendukung akses langsung ke papan klip. Silakan gunakan pintasan Ctrl+X/C/V dari keyboard.",
    "alignment": "penyejajaran",
    "austral sign": "tanda austral",
    "cedi sign": "tanda cedi",
    "colon sign": "tanda titik dua",
    "cruzeiro sign": "tanda cruzeiro",
    "currency sign": "tanda mata uang",
    "dollar sign": "tanda dolar",
    "dong sign": "tanda dong",
    "drachma sign": "tanda drachma",
    "euro-currency sign": "tanda mata uang eropa",
    "example": "contoh",
    "formatting": "pemformatan",
    "french franc sign": "tanda franc prancis",
    "german penny symbol": "simbol penny jerman",
    "guarani sign": "tanda guarani",
    "history": "riwayat",
    "hryvnia sign": "tanda hryvnia",
    "indentation": "indentasi",
    "indian rupee sign": "tanda rupee india",
    "kip sign": "tanda kip",
    "lira sign": "tanda lira",
    "livre tournois sign": "tanda livre tournois",
    "manat sign": "tanda manat",
    "mill sign": "tanda mill",
    "naira sign": "tanda naira",
    "new sheqel sign": "tanda sheqel baru",
    "nordic mark sign": "tanda mark nordik",
    "peseta sign": "tanda peseta",
    "peso sign": "tanda peso",
    "ruble sign": "tanda ruble",
    "rupee sign": "tanda rupee",
    "spesmilo sign": "tanda spesmilo",
    "styles": "gaya",
    "tenge sign": "tanda tenge",
    "tugrik sign": "tanda tugrik",
    "turkish lira sign": "tanda lira turki",
    "won sign": "tanda won",
    "yen character": "karakter yen",
    "yen/yuan character variant one": "varian satu karakter yen/yuan",
    "yuan character": "karakter yuan",
    "yuan character, in hong kong and taiwan": "karakter yuan, di hong kong dan taiwan",
    "{0} characters": "{0} karakter",
    "{0} columns, {1} rows": "Kolom {0}, baris {1}",
    "{0} words": "{0} kata"
});